import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CalendarRoutingModule } from './calendar-routing.module';
import { CalendarBootstrapComponent } from './componentes/calendar-bootstrap/calendar-bootstrap.component';
import { CalendarFiltersComponent } from './componentes/calendar-filters/calendar-filters.component';
import { CalendarTableComponent } from './componentes/calendar-table/calendar-table.component';
import { CalendarDetailComponent } from './componentes/calendar-detail/calendar-detail.component';
import { CoreModule, ServicesModule, CacheInterceptorService } from 'world-archery-lib';
import { CalendarFilterService } from './services/calendar-filter.service';
import { CalendarListComponent } from './componentes/calendar-list/calendar-list.component';
import { FeaturedEventsComponent } from './componentes/featured-events/featured-events.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '@environments/environment';
import { CommonPageComponentsModule } from '../../common-page-components/common-page-components.module';
@NgModule({
  declarations: [
    CalendarBootstrapComponent,
    CalendarFiltersComponent,
    CalendarTableComponent,
    CalendarDetailComponent,
    CalendarListComponent,
    FeaturedEventsComponent
  ],
  imports: [
    CommonModule,
    CalendarRoutingModule,
    CoreModule,
    SlickCarouselModule,
    ServicesModule,
    CommonPageComponentsModule
  ],
  providers: [
    CalendarFilterService,
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptorService, multi: true }
  ],
  exports: [
    CalendarBootstrapComponent,
    CalendarFiltersComponent,
    CalendarTableComponent,
    CalendarDetailComponent,
    CalendarListComponent,
    FeaturedEventsComponent
  ]

})
export class CalendarModule {
  constructor() {
    if (environment.production === true) {
      console.log = () => {

      }
    }
  }
}
